export const calculateConsignorSplit = (values, changedField) => {
  const netAmount = Number(values.amount || 0) - Number(values.discount || 0);
  if (changedField === "consigneeSplit") {
    const consigneeSplit = Math.round(Number(values.consigneeSplit || 0));
    return {
      consigneeSplit,
      consigneeSplitRate: netAmount
        ? Number(((consigneeSplit / netAmount) * 100).toFixed(2))
        : 0,
    };
  }
  const consigneeSplitRate = Number(
    Number(values.consigneeSplitRate || 0).toFixed(2),
  );
  return {
    consigneeSplitRate,
    consigneeSplit: Math.round((netAmount * consigneeSplitRate) / 100),
  };
};
